"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimePicker = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const shiftTZLocalToX_1 = __importDefault(require("@opsbase/lib-time/helpers/shiftTZLocalToX"));
const shiftTZXToLocal_1 = __importDefault(require("@opsbase/lib-time/helpers/shiftTZXToLocal"));
const lib_validator_1 = __importDefault(require("@opsbase/lib-validator"));
const ClockIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ClockIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
function TimePicker(props) {
    const { timezone, value, onChange } = props, otherProps = __rest(props, ["timezone", "value", "onChange"]);
    const time = (0, moment_timezone_1.default)(timezone ? (0, shiftTZXToLocal_1.default)(value, timezone) : value);
    const [timeStr, setTimeStr] = (0, react_1.useState)(time.format('hh:mm'));
    const isPM = time.format('A') === 'PM';
    (0, react_1.useEffect)(() => setTimeStr(time.format('hh:mm')), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [time.toDate().getTime()]);
    const handleChange = (0, react_1.useCallback)(v => {
        let hours = parseInt(v.split(':')[0]);
        let mins = parseInt(v.split(' ')[0].split(':')[1]);
        if (hours < 12 && isPM)
            hours += 12;
        if (hours === 12 && !isPM)
            hours = 0;
        if (hours < 0)
            hours = 0;
        if (hours > 24)
            hours = 24;
        if (mins < 0)
            mins = 0;
        if (mins > 59)
            mins = 59;
        const localValue = timezone ? (0, shiftTZXToLocal_1.default)(value, timezone) : value;
        let newDate = (0, moment_timezone_1.default)(localValue)
            .clone()
            .hours(hours)
            .minutes(mins)
            .seconds(0)
            .milliseconds(0);
        setTimeStr(newDate.format('hh:mm'));
        newDate = timezone ? (0, shiftTZLocalToX_1.default)(newDate, timezone) : newDate;
        if (onChange)
            onChange(newDate);
    }, [isPM, onChange, timezone, value]);
    const handleToggleAMPM = (0, react_1.useCallback)(() => {
        if (onChange)
            onChange(isPM ? (0, moment_timezone_1.default)(value).subtract(12, 'hours') : (0, moment_timezone_1.default)(value).add(12, 'hours'));
    }, [isPM, onChange, value]);
    return (react_1.default.createElement(TextFieldWithStateAndBlur_1.default, Object.assign({ validator: lib_validator_1.default.schemas().time, InputProps: {
            endAdornment: (react_1.default.createElement(Horizontal_1.default, { gutter: true, centered: true },
                react_1.default.createElement(Button_1.default, { tiny: true, color: lib_palette_1.default.GreyBlue, onClick: handleToggleAMPM }, isPM ? 'PM' : 'AM'),
                react_1.default.createElement(ClockIcon_1.default, null))),
        }, value: timeStr, onBlur: handleChange }, otherProps)));
}
exports.TimePicker = TimePicker;
exports.default = TimePicker;
